import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { ICountry } from 'models/country';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';


interface Props {
  open: boolean;
  loading: boolean;
  countries: ICountry[];
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const AddVendor: React.FC<Props> = ({ open, loading, countries, onClose, onSubmit, onChanges }) => {
  const { t } = useTranslation()
  let countryOptions = countries.map((country) => {
    return { value: country.id, label: country.name };
  });
  let basicFields: IFormField[] = [
    {
      name: 'Name',
      label: t('T_name'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_name'),
      internalLabel: true,
      required: true
    },
    {
      name: 'NameAr',
      label: `${t('T_name')} ${t('T_in_arabic')}`,
      type: InputTypes.TEXT,
      placeholder: `${t('T_enter_name')} ${t('T_in_arabic')}`,
      internalLabel: true,
      required: true
    },
        {
      name: 'Email',
      label: t('T_email'),
      type: InputTypes.EMAIL,
      placeholder: t('T_email'),
      internalLabel: true,
      required: true
    },
    {
      name: 'Username',
      label: t('T_username'),
      type: InputTypes.TEXT,
      placeholder: t('T_username'),
      internalLabel: true,
      required: true
    },
    {
      name: 'Approved',
      label: t('T_approved'),
      type: InputTypes.SWITCH,
      internalLabel: true
    },
    {
      name: 'RegistrationNumber',
      label: t('T_registration_number'),
      type: InputTypes.NUMBER,
      placeholder: t('T_registration_number'),
      internalLabel: true,
      required: true
    },
    {
      name: 'CountryId',
      label: t('T_country_name'),
      type: InputTypes.SELECT,
      placeholder: t('T_country_name'),
      options: countryOptions,
      multiple: false,
      internalLabel: true,
      required: true
    },
    {
      name: 'Logo',
      label: t('T_Logo'),
      type: InputTypes.FILE,
      internalLabel: true
    }

  ];

  let basicFields2: IFormField[] = [
      {
        name: "CountryCode",
        label: t("T_country_code"),
        type: InputTypes.COUNTRY,
        internalLabel: true,
        rows: 4,
        required: true,
      },
    ]
  
    let basicFields3: IFormField[] = [
  
      {
        name: "PhoneNumber",
        label: t("T_phone_number"),
        type: InputTypes.TEXT,
        placeholder: t("T_enter_phone_number"),
        internalLabel: true,
        rows: 4,
        required: true,
      },
    ]



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_add_vendor')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
        <div>
                      <div style={{ display: 'flex' }}>
                        <div style={{ width: '25%' }}>
                          <Form
                            fields={basicFields2}
                            onChange={onChanges}
                          />
                        </div>
        
                        <div style={{ width: '75%' }}>
                          <Form
                            fields={basicFields3}
                            onChange={onChanges}
                          />
                        </div>
                      </div>
                    </div>
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_add')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default AddVendor;
